import axios from 'axios';

import { env } from 'env';

const { REACT_APP_API_URL } = env;

export default class SDService {
  static crowningMomentDownload(params: {
    gender: string;
    persona: string;
  }): Promise<{ file: string }> {
    return axios
      .get(`${REACT_APP_API_URL}api/v2/ixr/sd/crowning/download`, {
        params,
      })
      .then((res) => res.data);
  }
}
